import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import App from './App';
import { AuthProvider } from './contexts/AuthContext';
import AppErrorBoundary from './components/common/AppErrorBoundary';
import { consumeImpersonationHandoff } from './services/authStorage';
import './index.css';

// Read-only "View as user": if this tab was opened with an impersonation token
// in the URL hash, install it (per-tab sessionStorage) and strip the hash
// BEFORE React/AuthContext mounts, so the app boots directly as that user.
consumeImpersonationHandoff();

const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#90caf9',
    },
    secondary: {
      main: '#f48fb1',
    },
    background: {
      default: '#121212',
      paper: '#1e1e1e',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <AppErrorBoundary>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <AuthProvider>
              <App />
            </AuthProvider>
          </LocalizationProvider>
        </AppErrorBoundary>
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>
);